import React from "react";

import Button from "../button/Button";

import type { JSX } from "react";

interface DownloadFileButtonProps {
  filename: string;
  datas: BlobPart;
  type: string;
  label?: string;
  icon?: React.ReactNode;
}

function DownloadFileButton({
  filename,
  datas,
  type,
  label,
  icon,
}: DownloadFileButtonProps): JSX.Element {
  const downloadFile = (): void => {
    const link = document.createElement("a");
    link.download = filename;
    const blob = new Blob([datas], { type });
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <Button onClick={downloadFile} size="md" type="button">
      {icon}
      {label}
    </Button>
  );
}

export default DownloadFileButton;
